import Model from "../Model";

class KpiEmployeeUser extends Model{

    buildUrl ({ param }) {
        return ['kpiemployee/getbyuserid', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new KpiEmployeeUser;